import Vue from 'vue'
import esJson from '../translations/es.json'
import enJson from '../translations/en.json'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'en',
    messages: {
        es: esJson,
        en: enJson,
    },
})

export {
    i18n,
}